/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios, {AxiosResponse, AxiosError} from 'axios';
import aws4Interceptor from './aws4Interceptor';
import { SignatureV4 } from '@aws-sdk/signature-v4';
import { Sha256 } from '@aws-crypto/sha256-js';
import appConfig from "../configs/appConfig.json";
import { makeCognitoRequest } from '../api/AWS';
import { CONSTANTS } from '../constants/contants';

let userData:any = [];

const getZoneID = () => {
  const userLocalData = localStorage.getItem('userData');

  if(userLocalData) {
    userData = JSON.parse(userLocalData);
  }
  return parseInt(sessionStorage.getItem('currentZone') || localStorage.getItem('currentZone') || userData.zoneId)
}

let accessToken: string | void;
const getAwsCredentials = (): ICredentials => ({
  accessKeyId: localStorage.getItem('accessKeyId') || '',
  secretAccessKey: localStorage.getItem('secretAccessKey') || '',
  sessionToken: localStorage.getItem('sessionToken') || '',
});

const sigv4 = new SignatureV4({
  service: 'execute-api',
  region: process.env.REACT_APP_AWS_CONFIG_REGION || '',
  credentials: async () => getAwsCredentials(),
  sha256: Sha256,
});

export enum HttpMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Patch = 'PATCH',
  Delete = 'DELETE',
}

export interface InterceptorOptions {
  service: string;
  region: string;
}

export interface ICredentials {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken?: string;
}

const interceptor = aws4Interceptor(
  {
    region: process.env.REACT_APP_AWS_CONFIG_REGION || '',
    service: "execute-api",
  },
  getAwsCredentials
);

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  // console.info(`[response] [${JSON.stringify(response)}]`);
  return response;
};

const onResponseError = async (error: AxiosError): Promise<AxiosError | AxiosResponse> => {
  const originalRequest: any = error?.config;
  const status = error?.response?.status;
  const isExpiredToken =
    status === 403 ||
    //@ts-ignore
    error?.response?.data?.message === 'The security token included in the request is expired';

  if (
    originalRequest?.url &&
    !originalRequest._retryWithFreshCredentials &&
    (status === 401 || isExpiredToken) &&
    localStorage.getItem('idToken')
  ) {
    try {
      const credential: any = await makeCognitoRequest(localStorage.getItem('idToken') || '');
      if (credential?.sessionToken) {
        originalRequest._retryWithFreshCredentials = true;
        return axios(originalRequest);
      }
    } catch (err) {
      console.log(err);
    }
  }

  return Promise.reject(error);
};

const getEncodedZoneList = () => {
  return localStorage.getItem('encoded_zones')
}

const getEncodedUserMeta = () => {
    return localStorage.getItem('user_meta')
}

export const getUserData = (key?: any) => {
  const userLocalData = localStorage.getItem('userData');

  if (userLocalData) {
    userData = JSON.parse(userLocalData);
  }
  if (!key) {
    return {
      email: userData['email'],
      name: userData['fullName'],
      role: userData['role'],
      user_id: userData['userId'],
      tz_name: userData['tz_name'],
      global: sessionStorage.getItem('globalZone') === "true"
    }
  }
  return userData[key]
}

axios.interceptors.request.use(interceptor, onRequestError);
axios.interceptors.response.use(onResponse, onResponseError);

export const httpClient = (url: string, method: HttpMethod, bodyData: any) => {
  return new Promise((resolve, reject) => {
    const baseURL = process.env.REACT_APP_BASE_API_URL;
    const hostName = process.env.REACT_APP_HOSTNAME || /* istanbul ignore next */'';
    const params: any = {method, url: `${baseURL}${url}`};
    const userData = getUserData()
    // @ts-ignore
    const signed = sigv4.sign({
      method: method,
      hostname: hostName,
      path: url,
      protocol: 'https',
      headers: {
        'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'x-meta-zones': getEncodedZoneList(),
        // 'Content-Type': 'application/json',
        host: hostName, // compulsory
      },
    });
    if(bodyData) {
      params.body = bodyData
      params.body = Object.assign({}, params.body, {
          zones: getEncodedZoneList(),
          zoneId: getZoneID(),
          userMeta: getEncodedUserMeta(),
          user_email: userData.email,
          global: userData.global
      })
    } else {
      params.body = {
          zones: getEncodedZoneList(),
          zoneId: getZoneID(),
          userMeta: getEncodedUserMeta(),
          user_email: userData.email,
          global: userData.global
      }
    }
    try {
      // getAccessToken().then((token:any) => {
      //   accessToken = token;
        const data = axios({
          ...signed,
          data: JSON.stringify(params.body),
          method: method,
          url: `${baseURL}${url}`, // compulsory
        });
      /* istanbul ignore next */
        data.then((response) => {
          // console.log('Successfully received data: ', response);
          resolve(response);
        }).catch((error) => {
          if(error.response.data === undefined) {
            reject(error);
            return
          } else if (error?.response?.data?.message === "The security token included in the request is expired") {
              localStorage.clear();
              reject(error);
              window.location.reload();
          }
          reject(error);
        });
      // });
    } catch (error) {
      // console.log('An error occurred', error);
      reject(error);
    }
  });
};

export const getAccessToken = (): Promise<string | void> => {
  const idToken = localStorage.getItem('idToken');

  const accessToken = makeCognitoRequest(idToken || /* istanbul ignore next */'').then((result:any) => {
    return result.sessionToken;
  }).catch((e) => console.log(e));

  return accessToken;
};
